import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

const RELOAD_TIMESTAMP_KEY = 'chunkLoadErrorReloadedAt';
const RELOAD_COOLDOWN_MS = 10_000;

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  private readonly sentryHandler = Sentry.createErrorHandler();

  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);
    const isChunkLoadError =
      message.includes('error loading dynamically imported module') ||
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Loading chunk') ||
      message.includes('ChunkLoadError');

    // A reload fetches the current build; if the chunk still fails right after one, report it instead of looping
    if (isChunkLoadError && this.reloadOnce()) {
      return;
    }

    // 401s are already handled by JwtInterceptor (token refresh or logout + redirect to login)
    if (error instanceof HttpErrorResponse && error.status === 401) {
      return;
    }

    this.sentryHandler.handleError(error);
  }

  private reloadOnce(): boolean {
    try {
      const lastReload = Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY));
      if (lastReload && Date.now() - lastReload < RELOAD_COOLDOWN_MS) {
        return false;
      }
      sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
    } catch {
      // sessionStorage unavailable - reload without loop protection
    }
    window.location.reload();
    return true;
  }
}
